export default __webpack_public_path__ + "static/media/knightIcon.cb9c7922.png";